import axios from "axios";

export const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api-eyazs-maputo-production.up.railway.app"
)
  .trim()
  .replace(/^["']|["']$/g, "")
  .replace(/\/$/, "");

const api = axios.create({
  baseURL: API_BASE_URL,
});

export function authHeaders(token) {
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export default api;
